import React from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import { withGuestAccess } from 'utils/withAuthorization'
import { ResetPassword } from 'features/Login/components/ResetPassword'

export const getServerSideProps: GetServerSideProps = withGuestAccess

export default function ResetPasswordPage() {
  const { t } = useTranslation()
  return (
    <div>
      <Head>
        <title>{t('reset-password:title')}</title>
      </Head>

      <main>
        <ResetPassword />
      </main>
    </div>
  )
}
